import { render, staticRenderFns } from "./DeactivateLineComponent.vue?vue&type=template&id=16b22a10&"
import script from "./DeactivateLineComponent.vue?vue&type=script&lang=js&"
export * from "./DeactivateLineComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports